"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VOCAL_TRACK_DISPLAY_IDS = exports.TRAINING_IDS = exports.TRAINING = exports.TRACTOR_BEAM_STATION = exports.THRUSTERS_STATION = exports.ROBOT_ACTION_TYPE = exports.QUESTION_PHASE = exports.NO_OBJECTIVE = exports.MISSION_TYPES = exports.MISSION_PHASES = exports.MISSION_EVENTS = exports.MISSION_CATEGORIES = exports.MAX_SHIP_HEALTH = exports.LITERACY_EVENT = exports.HEALTH_TASK_TYPE = exports.DEFENSE_STATION = exports.CREATIVE_CANVAS_STATION = exports.COLLABORATIVE_CULMINATING_MOMENT = void 0;
var _questionToolkit = require("@mission.io/question-toolkit");
// Default value when there is no current objective
const NO_OBJECTIVE = exports.NO_OBJECTIVE = 'No Current Objective';

// All possible mission phases
const MISSION_PHASES = exports.MISSION_PHASES = {
  LOGIN: 'LOGIN',
  TRAINING: 'TRAINING',
  ACTIVE: 'ACTIVE',
  SURVEY_STANDBY: 'SURVEY_STANDBY',
  REVIEW_RESULTS: 'REVIEW_RESULTS',
  CLOSED: 'CLOSED'
};
const MISSION_TYPES = exports.MISSION_TYPES = {
  K_THROUGH_3: 'K-3',
  FOUR_PLUS: '4+'
};
const MAX_SHIP_HEALTH = exports.MAX_SHIP_HEALTH = 100;
const MISSION_CATEGORIES = exports.MISSION_CATEGORIES = {
  ON_SITE: 'ON_SITE',
  WHOLE_CLASS_REMOTE: 'WHOLE_CLASS_REMOTE',
  SQUADRON_REMOTE: 'SQUADRON_REMOTE',
  SQUADRON_HOMEWORK: 'SQUADRON_HOMEWORK'
};
const MISSION_EVENTS = exports.MISSION_EVENTS = {
  BEGIN_PREP: 'BEGIN_PREP',
  OPEN_MISSION: 'OPEN_MISSION',
  START_MISSION: 'START_MISSION',
  RESTORE_MISSION: 'RESTORE_MISSION',
  SAVE_FOR_LATER: 'SAVE_FOR_LATER',
  END_MISSION: 'END_MISSION'
};
const HEALTH_TASK_TYPE = exports.HEALTH_TASK_TYPE = {
  HIGH_FIVE: 'HIGH_FIVE',
  COMPLIMENT: 'COMPLIMENT',
  HAND_SHAKE: 'HAND_SHAKE',
  CHEESY_JOKE: 'CHEESY_JOKE',
  ENCOURAGEMENT: 'ENCOURAGEMENT',
  FIST_BUMP: 'FIST_BUMP',
  AIR_FIVE: 'AIR_FIVE',
  THUMBS_UP: 'THUMBS_UP',
  POINT_AND_NOD: 'POINT_AND_NOD'
};
const ROBOT_ACTION_TYPE = exports.ROBOT_ACTION_TYPE = {
  INVESTIGATING: 'INVESTIGATING'
};

// STATION CONSTANTS

const DEFENSE_STATION = exports.DEFENSE_STATION = {
  STATUS: {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE'
  },
  UPGRADES: [{
    index: 0,
    damage: 20
  }, {
    index: 1,
    damage: 20
  }, {
    index: 2,
    damage: 25
  }, {
    index: 3,
    damage: 25
  }],
  DEFAULT_UPGRADE: 2,
  MOVEMENT: {
    RANDOM: 'RANDOM',
    STRAIGHT_LINE: 'STRAIGHT_LINE',
    STATIC: 'STATIC'
  },
  LOCATION: {
    RANDOM: 'RANDOM',
    DEFINED: 'DEFINED'
  },
  RESPAWN: {
    ALWAYS: 'ALWAYS',
    NEVER: 'NEVER'
  },
  OBJECT_SHARING: {
    SEPARATE: 'SEPARATE'
  },
  EXIT_ANIMATION: {
    FADE_OUT: 'FADE_OUT'
  }
};
const TRACTOR_BEAM_STATION = exports.TRACTOR_BEAM_STATION = {
  STATUS: {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE'
  },
  DEFAULT_UPGRADE: 2,
  MOVEMENT: {
    RANDOM: 'RANDOM',
    STATIC: 'STATIC'
  },
  LOCATION: {
    RANDOM: 'RANDOM',
    DEFINED: 'DEFINED'
  },
  RESPAWN: {
    ALWAYS: 'ALWAYS',
    NEVER: 'NEVER'
  }
};
const THRUSTERS_STATION = exports.THRUSTERS_STATION = {
  DEFAULT_UPGRADE: 2,
  MAX_UPGRADE_LEVEL: 3
};
const CREATIVE_CANVAS_STATION = exports.CREATIVE_CANVAS_STATION = {
  VARIANT: {
    ISSUE_PER_TEAM: 'ISSUE_PER_TEAM',
    GENERAL_ISSUE: 'GENERAL_ISSUE'
  },
  RUBRIC: {
    CRITERIA: {
      DISPLAY_TYPE: {
        VISIBLE: 'VISIBLE',
        HIDDEN: 'HIDDEN',
        HIDE_IN_EDIT_MODE: 'HIDE_IN_EDIT_MODE'
      }
    }
  },
  IMAGE_UPLOAD_STATUS: {
    READY: 'READY',
    ERROR: 'ERROR',
    COMPLETE: 'COMPLETE'
  },
  CANVAS_TOOLS: {
    TEXT: 'TEXT',
    DRAW: 'DRAW',
    SHAPE: 'SHAPE',
    IMAGE: 'IMAGE'
  }
};

// END STATION CONSTANTS

const COLLABORATIVE_CULMINATING_MOMENT = exports.COLLABORATIVE_CULMINATING_MOMENT = {
  ENDING: {
    CLASS_VOTE: 'CLASS_VOTE',
    EACH_RESPONSE: 'EACH_RESPONSE',
    ALL_RESPONSES: 'ALL_RESPONSES'
  },
  SCREEN_STATUS: {
    EDITING: 'EDITING',
    AWAITING_TEACHER_TO_CONTINUE: 'AWAITING_TEACHER_TO_CONTINUE',
    GRADING_UNHIDDEN: 'GRADING_UNHIDDEN',
    VOTING: 'VOTING',
    GRADING_HIDDEN: 'GRADING_HIDDEN',
    GRADING_ALL: 'GRADING_ALL',
    DISPLAY_RESULTS: 'DISPLAY_RESULTS'
  }
};
const QUESTION_PHASE = exports.QUESTION_PHASE = {
  STATUS: {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE'
  },
  STATIONS: {
    COMMUNICATION: 'COMMUNICATION',
    POWER: 'POWER',
    DEFENSE: 'DEFENSE',
    TRACTOR_BEAM: 'TRACTOR_BEAM',
    TRANSPORTER: 'TRANSPORTER',
    THRUSTERS: 'THRUSTERS',
    REPAIRS: 'REPAIRS'
  }
};
const LITERACY_EVENT = exports.LITERACY_EVENT = {
  SIMULATION_ACTION_TYPE: 'LITERACY_EVENT',
  TASK: {
    TYPE: {
      MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
      SPEAKING: 'SPEAKING',
      CLOSE_READING: 'CLOSE_READING'
    },
    SPEAKING_TASK_DISCRIMINATORS: {
      TARGET: {
        NONE: 'NONE',
        STUDENT: 'STUDENT'
      },
      STATUS: {
        NOT_YET_STARTED: 'NOT_YET_STARTED',
        WAITING_FOR_TIMER_TO_FINISH: 'WAITING_FOR_TIMER_TO_FINISH',
        WAITING_FOR_FINISH_MESSAGE: 'WAITING_FOR_FINISH_MESSAGE',
        WAITING_FOR_DISMISS_MESSAGE: 'WAITING_FOR_DISMISS_MESSAGE'
      }
    },
    CLOSE_READING: {
      ..._questionToolkit.CLOSE_READING,
      STATUS: {
        WAITING_FOR_DISMISS_FEEDBACK_MESSAGE: 'WAITING_FOR_DISMISS_FEEDBACK_MESSAGE',
        WAITING_FOR_SUBMISSION_MESSAGE: 'WAITING_FOR_SUBMISSION_MESSAGE'
      }
    }
  },
  DATA_APPEARANCE: {
    LOCATION: {
      MAP: 'MAP',
      CREATIVE_CANVAS_STATION: 'CREATIVE_CANVAS_STATION',
      NONE: 'NONE'
    }
  },
  ASSIGNMENT: {
    TYPE: {
      GENERAL: 'GENERAL',
      PER_TEAM: 'PER_TEAM'
    }
  },
  LITERACY_EVENT_STATUS: {
    ACTIVE: 'ACTIVE',
    PAUSED: 'PAUSED'
  }
};
const TRAINING_IDS = exports.TRAINING_IDS = {
  WELCOME: 'WELCOME',
  QUICK_SUMMARY: 'QUICK_SUMMARY',
  HEALTH_1: 'HEALTH_1',
  HEALTH_2: 'HEALTH_2',
  HEALTH_3: 'HEALTH_3',
  HEALTH_4: 'HEALTH_4',
  HEALTH_5: 'HEALTH_5',
  HEALTH_TASK_1: 'HEALTH_TASK_1',
  HEALTH_TASK_2: 'HEALTH_TASK_2',
  HEALTH_TASK_3: 'HEALTH_TASK_3',
  HEALTH_TASK_4: 'HEALTH_TASK_4',
  REPAIRS_1: 'REPAIRS_1',
  REPAIRS_2: 'REPAIRS_2',
  REPAIRS_3: 'REPAIRS_3',
  REPAIRS_4: 'REPAIRS_4',
  REPAIRS_5: 'REPAIRS_5',
  REPAIRS_6: 'REPAIRS_6',
  ENGINEERING_PANEL_1: 'ENGINEERING_PANEL_1',
  ENGINEERING_PANEL_2: 'ENGINEERING_PANEL_2',
  CREATIVE_CANVAS_ICON_CLICK: 'CREATIVE_CANVAS_ICON_CLICK',
  CREATIVE_CANVAS_EXPLAINED: 'CREATIVE_CANVAS_EXPLAINED',
  CREATIVE_CANVAS_PROMPT_EXPLAINED: 'CREATIVE_CANVAS_PROMPT_EXPLAINED',
  CREATIVE_CANVAS_RUBRIC_AND_DATA_EXPLAINED: 'CREATIVE_CANVAS_RUBRIC_AND_DATA_EXPLAINED',
  SENSORS_1: 'SENSORS_1',
  SENSORS_2: 'SENSORS_2',
  SENSORS_3: 'SENSORS_3',
  MAP_OBJECT_ACTION_7: 'MAP_OBJECT_ACTION_7',
  MAP_OBJECT_ACTION_8: 'MAP_OBJECT_ACTION_8',
  COLLECTED_DATA_1: 'COLLECTED_DATA_1',
  COLLECTED_DATA_2: 'COLLECTED_DATA_2',
  // add these ids to order
  ACTIVATE_STATION_1: 'ACTIVATE_STATION_1',
  ACTIVATE_STATION_2: 'ACTIVATE_STATION_2',
  ACTIVATE_STATION_3: 'ACTIVATE_STATION_3',
  ACTIVATE_STATION_4: 'ACTIVATE_STATION_4',
  ANSWER_QUESTION: 'ANSWER_QUESTION',
  REVIEW_QUESTION: 'REVIEW_QUESTION',
  CLOSE_QUESTION: 'CLOSE_QUESTION',
  PRO_TIP_1: 'PRO_TIP_1',
  PRO_TIP_2: 'PRO_TIP_2',
  PRO_TIP_3: 'PRO_TIP_3',
  PRO_TIP_4: 'PRO_TIP_4',
  END: 'END'
};
const TRAINING = exports.TRAINING = {
  IDS: TRAINING_IDS,
  ORDER: [TRAINING_IDS.WELCOME, TRAINING_IDS.QUICK_SUMMARY, TRAINING_IDS.ACTIVATE_STATION_1, TRAINING_IDS.ACTIVATE_STATION_2, TRAINING_IDS.ACTIVATE_STATION_3, TRAINING_IDS.ANSWER_QUESTION, TRAINING_IDS.REVIEW_QUESTION, TRAINING_IDS.CLOSE_QUESTION, TRAINING_IDS.HEALTH_1, TRAINING_IDS.HEALTH_2, TRAINING_IDS.HEALTH_3, TRAINING_IDS.HEALTH_TASK_1, TRAINING_IDS.HEALTH_TASK_2, TRAINING_IDS.HEALTH_TASK_3, TRAINING_IDS.HEALTH_TASK_4, TRAINING_IDS.HEALTH_4, TRAINING_IDS.HEALTH_5, TRAINING_IDS.REPAIRS_1, TRAINING_IDS.REPAIRS_2, TRAINING_IDS.REPAIRS_3, TRAINING_IDS.REPAIRS_4, TRAINING_IDS.REPAIRS_5, TRAINING_IDS.REPAIRS_6, TRAINING_IDS.ENGINEERING_PANEL_1, TRAINING_IDS.ENGINEERING_PANEL_2, TRAINING_IDS.CREATIVE_CANVAS_ICON_CLICK, TRAINING_IDS.CREATIVE_CANVAS_EXPLAINED, TRAINING_IDS.CREATIVE_CANVAS_PROMPT_EXPLAINED, TRAINING_IDS.CREATIVE_CANVAS_RUBRIC_AND_DATA_EXPLAINED, TRAINING_IDS.SENSORS_1, TRAINING_IDS.SENSORS_2, TRAINING_IDS.SENSORS_3, TRAINING_IDS.MAP_OBJECT_ACTION_7, TRAINING_IDS.MAP_OBJECT_ACTION_8, TRAINING_IDS.COLLECTED_DATA_1, TRAINING_IDS.COLLECTED_DATA_2, TRAINING_IDS.PRO_TIP_1, TRAINING_IDS.PRO_TIP_2, TRAINING_IDS.PRO_TIP_3, TRAINING_IDS.PRO_TIP_4, TRAINING_IDS.END]
};
const VOCAL_TRACK_DISPLAY_IDS = exports.VOCAL_TRACK_DISPLAY_IDS = {
  ICON_ONLY: 'ICON_ONLY',
  SHOW_CHARACTER: 'SHOW_CHARACTER'
};